<!-- IconSelector with tooltips needs careful tradition, so abstract those logic here to make up a component standalone -->
<!-- 通常，我们需要配合 Tooltips 来使用 Iconfont Selector 组件，有这样的一些坑需要填补
     1. el-tooltip + iconfont-selector，必须保证 .el-tooltip 的宽度和 iconfont 的宽度等宽，否则焦点对不准确
     2. iconfont-selector 激活后不应该再弹出提示，比如是收藏 iconfont-selector，收藏后，不应该再弹出提示收藏。这部分逻辑通过捕获 iconfont-
        selector 的 actived 事件来进行判断。
     -> 为了实现简单，将逻辑简化了，tootip 提示现在限定只提示激活，比如提示"收藏频道"，若已经收藏了则不提示了（将 tooltip disabled 即可）
-->
<template>
    <!--
     FIXME：在 iconfont-selector 结合使用 el-tooltip 的时候，在 Safari 上有 Bug，点击 iconfont-selector 总是会出现一个扰人的边框，
     FIXME: 且这个情况只在 iconfont-selector + el-tooltip 的时候，如果 el-tooltip + button 有没有这个问题，因此，暂时将 el-tooltip
     FIXME：+ iconfont 的这种结合方式先 deprecated!
    -->
    <!--    <el-tooltip :content="tooltipText"-->
    <!--                :open-delay="600"-->
    <!--                placement="bottom">-->
    <!--        <iconfont-selector v-bind="$attrs" @actived="activeCallback"></iconfont-selector>-->
    <!--    </el-tooltip>-->
    <!-- 最佳实践，通过 v-bind="$attrs" 传递子组件需要的 props，这样在中间组件中无需重复定义参数了！这个是不小心在 el-input 的 textarea
         元素的源码中无意之中发现的。详细的使用方式参考《vue 不常见用法.md》
    -->
    <iconfont-selector ref="selector" v-bind="$attrs" @change="change" @init="init" :title="tooltipText_"></iconfont-selector>
</template>

<script>
    export default {
        name: "IconfontSelectorTooltip",
        props: {
            // 提示激活
            tooltipText: {
                type: String
            }
        },
        data() {
            return {
                tooltipText_: this.tooltipText
            }
        },
        methods: {

            /**
             * 对 tooltips 初始化
             * @param active
             */
            init(active){
                active ? this.tooltipText_ = "" : this.tooltipText_ = this.tooltipText;
            },

            /**
             * 这个方法提供对 tooltips 的反转功能。
             * @param active
             */
            change(active){
                // 如果已经激活了，则不要再提示了，因此将 tooltip text 置为空
                active ? this.tooltipText_ = "" : this.tooltipText_ = this.tooltipText;
                this.$emit('change', active); // 继续抛出 change 事件给 parent 捕获处理
            },

            revert(){
                this.$refs.selector.revert();
            }
        }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/commons/IconfontSelectorTooltip.vue